import React from "react"
import { Flex, ContentBox } from "src/components/Grid"
import styles from "./styles.css"

export default props => {
  const { bodyContent, buttons } = props

  return (
    <Flex style={{ height: `100%` }} column justify="space-between">
      <div>
        <header className={styles.header}>Правила ограничения:</header>
        <section>{bodyContent}</section>
      </div>
      <footer>
        <ContentBox bt>{buttons}</ContentBox>
      </footer>
    </Flex>
  )
}
